import { useEffect, useState } from "react";

import { getQuickList } from "services/sosInventoryService/sosApi";

export function useVendors(vendorAddedCount) {
  const [records, setRecords] = useState(null);

  useEffect(() => {
    async function retrieveRecords() {
      const response = await getQuickList("vendor", { inTransaction: true });
      setRecords(response.data);
    }
    retrieveRecords();
  }, [vendorAddedCount]);

  return records;
}
